export default "__VITE_ASSET__xy6jIrq8__"